import React from 'react';
import ErrorPage from '../components/ErrorPage/ErrorPage';

export default function Custom500() {
  return <ErrorPage title={'500'} text={'An error has occurred.'} />;
}
